import React, { ForwardedRef, useState } from "react";
import "./input-v1.css";
import { EyeIconV1, EyeOffIconV1 } from "images/image-component";

interface Props {
  name: string;
  label: string;
  type?: "text" | "password" | "email";
  value: string;
  onChange: (val: string) => void;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  placeholder?: string;
  autoComplete?: string;
}

const InputV1 = React.forwardRef<HTMLInputElement, Props>(
  (
    { name, label, type = "text", value, onChange, onKeyDown, placeholder, autoComplete },
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    const [visible, setVisible] = useState(false);
    const isPassword = type === "password";
    const resolvedType = isPassword ? (visible ? "text" : "password") : type;

    return (
      <div className="v1-field">
        <label className="v1-field-label" htmlFor={name}>{label}</label>
        <div className="v1-field-wrap">
          <input
            id={name}
            name={name}
            ref={ref}
            type={resolvedType}
            value={value}
            className={`v1-field-input${isPassword ? " has-toggle" : ""}`}
            placeholder={placeholder}
            autoComplete={autoComplete}
            onChange={(e) => onChange(e.target.value.replace(/\s+/g, ""))}
            onKeyDown={onKeyDown}
          />
          {isPassword && (
            <button
              type="button"
              className="v1-field-toggle"
              aria-label={visible ? "Hide password" : "Show password"}
              onClick={() => setVisible((v) => !v)}
            >
              {visible ? <EyeOffIconV1 /> : <EyeIconV1 />}
            </button>
          )}
        </div>
      </div>
    );
  }
);

export default InputV1;
